"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var hiver_config_library_1 = require("@hiver/hiver-config-library");
var fetch_1 = require("../fetch");
exports.getAnalyticsAuthToken = function () { return __awaiter(_this, void 0, void 0, function () {
    var email, BASE_URL;
    return __generator(this, function (_a) {
        email = hiver_config_library_1.getConfigKey('email');
        BASE_URL = hiver_config_library_1.getConfigKey('BASE_URL');
        if (!email || !BASE_URL) {
            throw Error('No email or BASE_URL provided');
        }
        if (hiver_config_library_1.getConfigKey('isMock')) {
            return [2, fetch_1.H_GET("http://localhost:9898/auth")];
        }
        return [2, fetch_1.H_GET(BASE_URL + "/api/hiverauth/auth?email=" + email)];
    });
}); };
exports.getAuthToken = function (AUTH_TOKEN_KEY) {
    if (AUTH_TOKEN_KEY === void 0) { AUTH_TOKEN_KEY = 'analytics_token'; }
    return hiver_config_library_1.getConfigKey(AUTH_TOKEN_KEY);
};
exports.getAndStoreAnalyticsAuthToken = function () { return __awaiter(_this, void 0, void 0, function () {
    var email, usersession, BASE_URL, authToken, token, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                email = hiver_config_library_1.getConfigKey('email');
                usersession = hiver_config_library_1.getConfigKey('usersession');
                BASE_URL = hiver_config_library_1.getConfigKey('BASE_URL');
                if (!email || !BASE_URL) {
                    throw Error('No email or BASE_URL provided');
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 6, , 7]);
                if (!hiver_config_library_1.getConfigKey('isMock')) return [3, 3];
                return [4, fetch_1.H_GET("http://localhost:9898/auth")];
            case 2:
                authToken = _a.sent();
                return [3, 5];
            case 3: return [4, fetch_1.H_GET(BASE_URL + "/api/hiverauth/auth?usersession=" + usersession + "&email=" + email, { method: 'get', credentials: 'include' })];
            case 4:
                authToken = _a.sent();
                _a.label = 5;
            case 5:
                if (authToken && authToken.parsedBody && authToken.parsedBody.token) {
                    token = authToken.parsedBody.token;
                    if (token) {
                        hiver_config_library_1.setConfigKey('analytics_token', token);
                        return [2, token];
                    }
                    throw Error('No token returned');
                }
                return [3, 7];
            case 6:
                err_1 = _a.sent();
                throw err_1.stack;
            case 7: return [2, ''];
        }
    });
}); };
//# sourceMappingURL=index.js.map